import { ApiBase } from 'api/api'
import { makePostRequest } from 'api/fetchCalls'

export async function syncAppointmentTypes(): Promise<void> {
  return makePostRequest(`${ApiBase}/calendar/appointment_types/sync`)
}
